import { css } from '@compiled/react';

import EpicObject from '@atlaskit/object/epic';

type Epic16IconCustomProps = {
	readonly primaryColor: string;
	readonly label: string;
};

export const Epic16IconCustom = ({ primaryColor, label }: Epic16IconCustomProps) => {
	const colorOverride = css({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- epic SVG paths need fill override for roadmap theme
		path: {
			fill: primaryColor,
		},
	});

	return (
		<div css={colorOverride}>
			<EpicObject label={label} />
		</div>
	);
};
